import Receipt from 'globalComponents/Receipt'
import React from 'react'

const ParkingActivateCompleted: React.FC = () => {
  return <Receipt origin='activate'/>
}

export default ParkingActivateCompleted